import React from "react";
import { ArrowUpRight } from "lucide-react";

/** Slim "Powered by HMT Technologies" strip for the top of shareable pages (match reports). */
export default function HmtBanner() {
  return (
    <a
      href="https://hmttechnologies.com"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center gap-1.5 px-4 py-2 bg-ink text-white/70 text-xs no-underline hover:text-white transition-colors"
      data-testid="hmt-banner"
    >
      <span>Powered by</span>
      <span className="font-bold text-white tracking-wide">HMT Technologies</span>
      <ArrowUpRight size={13} className="text-[#7CC242]" />
    </a>
  );
}
